import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import LoadingGif from '../../../../static/images/loading.gif';
import pushAnalytics from '../../../../analytics/pushAnalytics';

const COMPONENT_TREE = [
    { component_name: 'LoginPage', component_version: '1.0.0' },
    { component_name: 'UsernameForm', component_version: '1.0.0' }
];

class UsernameFormView extends React.Component {
    render() {
        return (
            /* FIXME: OnSubmit, the info is showing up in the URL */
            <Form id="logonFormUsername" noValidate validated={this.props.isUsernameValid} onSubmit={this.props.handleFormSubmit}>
                <Form.Group id="logonUsernameGroup" className="relative">
                    {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                    in order to disable native popup error*/}
                    <Form.Label className={`${this.props.floatLabel === true ? "absolute floating-label" : "absolute inline-label"}
                                              ${this.props.onFocus === true ? "label-black__TO" : ""}
                                              ${this.props.isUsernameValid === false && this.props.onFocus === false ? "label-red__TO" : ""}
                    
                    `} >Email or mobile number</Form.Label>
                    <Form.Control
                        required
                        id="logonUsername__TO"
                        data-testid="logonUsername"
                        aria-label="Username"
                        as="input"
                        type="text"
                        name="username"
                        placeholder=""
                        value={this.props.username ?? ""} // to keep input controlled
                        onChange={this.props.handleUsernameChange}
                        onFocus={() => {
                            if (!this.props.hasStarted) {
                                pushAnalytics('aa-action', { link_text: 'username', link_type: 'text', link_trigger: 'aa-action', content_section: 'Sign in Landing Page', user_login_source: "Email", metrics: 'km-sign-in-start' }, COMPONENT_TREE);
                                this.props.updateHasStarted(true);
                            }
                            this.props.setFocus()
                        }}
                        onBlur={this.props.onBlur}
                        bsPrefix={`${this.props.isUsernameValid === false && this.props.onFocus === false ? "highlight-error__TO" : ""} form-control`}
                    />
                    <div
                        id="usernameAlert"
                        data-testid="logonUsernameError"
                        className={`logon-item-error__TO ${this.props.isUsernameValid === false && this.props.onFocus === false ? "block" : "none"}`}
                        role="alert"
                        aria-hidden={`${this.props.isUsernameValid === false && this.props.onFocus === false ? "false" : "true"}`}
                    >
                        Please enter a valid email or mobile number.
                    </div>
                </Form.Group>
                <div className="username-button-grid" id={this.props.showAlert ? 'next-step' : 'next-step-disabled'}>
                    <Button id="logonButton" tabIndex={0} data-testid="logonButton" bsPrefix={`${this.props.isUsernameValid !== true ? "button-disabled__TO" : "button__TO "}`} type={`${this.props.isUsernameValid ? "submit" : ''}`} onClick={() => pushAnalytics('aa-action', { button_action: 'submitUsername', link_text: 'next step', ctaText: 'Next Step', initiator: 'user', link_trigger: 'aa-action', content_section: 'Sign in Landing Page', _tree: COMPONENT_TREE })}>Next Step</Button>
                </div>
                <Image data-testid="loadingGIF" className={`working ${this.props.loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
            </Form>
        );
    }
}

export default UsernameFormView;